{
    "PlaysoundLabel": "Play Sound (Requires Local Media Player):",
    "ActivewindowLabel": "Active Window (Single Tabbed IE/Firefox Browsers Only):",
    "NAME": "AlarmActions",
    "AlarmActions_SectionHeader": "Alarm Actions",
    "AlarmActions_SectionPara": "When alarms are activated, the corresponding report row and/or statistics will flash. Below you can choose additional actions that occur for the currently active report when one of its alarms first starts being triggered."
}